import { render } from "./NewActivityIcon.vue?vue&type=template&id=609b4cb9&scoped=true"
import script from "./NewActivityIcon.vue?vue&type=script&lang=js"
export * from "./NewActivityIcon.vue?vue&type=script&lang=js"

import "./NewActivityIcon.vue?vue&type=style&index=0&id=609b4cb9&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609b4cb9"]])

export default __exports__